import Image from 'next/image'
import React from 'react'

const TimerImage = () => {
  return (
    <Image
      className={' w-[39.32px] sm:w-[30px] 1.1xl:w-[39.32px] 1.1xl:h-[35.98px] my-auto'}
      src={'/exam/timer.png'}
      alt={'시간영역'}
      width={39.32}
      height={35.98}
    />
  )
}

export default React.memo(TimerImage)
